var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c(this.$store.state.layout,{tag:"component"}),_c('global-snackbar',{attrs:{"props":_vm.$store.state.globalSnackbarProps}}),_c('global-snackbar',{attrs:{"props":_vm.$store.state.notificationSnackbarProps}}),_c('loading-overlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }